import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import axios from "axios";
import global_ from '@/misc/global.vue';

export const standards = {
  namespaced: true,

  state: {
    // 通过关键字某一系列的标准全部清单（如通过关键字将27001，系列标准全部取出）
    // 该功能不对终端用户开发，主要用于热门系列标准、关联标准等功能
    serials: null,
    // 在标准代码、标准发布年限、标准名称中进行搜索，获得包含关键字的标准清单
    searchTitle: null,
    // 在标准条款内容中进行搜索，获得包含关键字的标准条款
    searchContents: null,
    // 通过关键字获取标准全文（ 如通过关键字将ISO / IEC 27001: 2013， 取出27001标准全文）
    standardsContents: null,
    // 取出标准对应的中文标准（如ISO27001与GB22080对应取出）
    relatedStandardsContents: null,
    // 根据标准代码获得标准的描述
    standardsDescription: null
  },

  mutations: {
    getSerials: async (state, params) => {
      // 获取系列标准（首页的热门标准，以及标准扩展信息中的关联标准）
      // params 为系列代码，如ISO 27001, ISO 20000等
      // 清空缓存数据
      Vue.set(state, 'serials', null)
      if (params != null) {
        await axios.get(global_.BAK_URL + "getStandardsSerials/", {
          params: {
            keywords: params
          },
          async: false
        }).then(response => {
          Vue.set(state, 'serials', response.data)
        }).catch(() => {
          Vue.set(state, 'serials', [])
        })
      }
    },

    searchTitle: async (state, params) => {
      // 在标准描述（包括代码、标准发布年限、标准名称等）中进行搜索，获得对应的标准清单
      Vue.set(state, 'searchTitle', null)
      await axios.get(global_.BAK_URL + "searchStandardsTitle/", {
        params: {
          keywords: params
        },
        async: false
      }).then(response => {
        Vue.set(state, "searchTitle", response.data);
      }).catch(() => {
        Vue.set(state, 'searchTitle', [])
      })
    },

    searchContents: async (state, params) => {
      // 在标准条款内容中进行搜索，获取与关键字相关的标准条款
      // 清空以前的搜索数据，防止误显示前次搜索结果
      Vue.set(state, 'searchContents', null)
      await axios.get(global_.BAK_URL + "searchStandardsContents/", {
        params: {
          keywords: params
        },
        async: false
      }).then(response => {
        Vue.set(state, 'searchContents', response.data)
      }).catch(() => {
        Vue.set(state, 'searchContents', [])
      })
    },

    // 通过关键字获取标准全文（ 如通过关键字将ISO / IEC 27001: 2013， 取出27001标准全文）
    getStandardsContents: async (state, params) => {
      Vue.set(state, 'standardsContents', null)
      await axios.get(global_.BAK_URL + "getStandardsContents/", {
        params: {
          keywords: params,
        },
        async: false
      }).then(response => {
        Vue.set(state, 'standardsContents', response.data)
      }).catch(() => {
        Vue.set(state, 'standardsContents', [])
      })
    },

    // 取出标准对应的中文标准（如ISO27001与GB22080对应取出）
    getRelatedStandardsContents: async (state, params) => {
      Vue.set(state, 'relatedStandardsContents', null)
      await axios.get(global_.BAK_URL + "getStandardsContents/", {
        params: {
          keywords: params,
        },
        async: false
      }).then(response => {
        Vue.set(state, 'relatedStandardsContents', response.data)
      }).catch(() => {
        Vue.set(state, 'relatedStandardsContents', [])
      })
    },

    // 根据标准代码获得标准的描述
    getStandardsDescription: async (state, params) => {
      Vue.set(state, 'standardsDescription', null)
      await axios.get(global_.BAK_URL + "getStandardsDescription/", {
        params: {
          keywords: params,
        },
        async: false
      }).then(response => {
        Vue.set(state, 'standardsDescription', response.data[0])
      })
    }
  },

  actions: {
    // 获取系列标准
    getSerials: (context, params) => {
      context.commit("getSerials", params)
    },
    // 在标准代码、标准发布年限、标准名称中进行搜索，获得包含关键字的标准清单
    searchTitle: (context, params) => {
      context.commit("searchTitle", params)
    },
    // 在标准条款内容中进行搜索，获得包含关键字的标准条款
    searchContents: (context, params) => {
      context.commit("searchContents", params)
    },
    // 读取标准全文
    getStandardsContents: (context, params) => {
      context.commit("getStandardsContents", params)
    },
    // 取出标准对应的中文标准（如ISO27001与GB22080对应取出）
    getRelatedStandardsContents: (context, params) => {
      context.commit("getRelatedStandardsContents", params)
    },
    // 根据标准代码获得标准的描述
    getStandardsDescription: (context, params) => {
      context.commit("getStandardsDescription", params)
    },
  }
}